/** AdventHealth PS00364 / PS00374 labels. Same strings as iOS EConsentFormCopy. */

const en: Record<string, string> = {
  doctorName: "Doctor",
  procedure: "Name of Surgery or Procedure – include site, side and level, if applicable",
  secondDoctorName: "If having 2nd Surgery / Procedure:",
  secondProcedure: "Name of Surgery or Procedure – include site, side and level, if applicable",
  otherRisks: "Other risks involved. These are listed below:",
  biopsyChoice: "Check a box in Section A. or B. below",
  dna_yes:
    "YES, I want DNA analysis testing if needed to find out what is causing my problem.",
  dna_no:
    "NO, I do NOT want DNA analysis testing. If DNA analysis testing is needed, I understand that my doctor may not be able to diagnose or properly treat me.",
  no_biopsy: "B. No biopsy samples to be taken.",
  whichISpeak: "which I speak fluently.",
  unableReason: "Patient unable to sign because:",
  sedated: "sedated",
  confused: "confused / not alert or oriented",
  other: "other (specify)",
  unableOther: "other (specify)",
  patientPrintName: "Print Patient's First and Last Name",
  authorizedName: "Print Name",
  authorizedRelationship: "Relationship",
  witnessPrintName: "Witness Print Name",
  interpreterMode: "Qualified Staff / Interpreter Signature",
  phone: "Phone",
  video: "Video",
  interpreterName: "Print Qualified Staff / Interpreter Name",
  interpreterId: "ID Number",
  interpreterLanguage: "Language Interpreted",
  physicianId: "ID #",
  physicianLanguage: "Language Interpreted",
  consentedInLanguage: "I consented this patient in:",
  secondPhysicianId: "ID #",
  secondPhysicianLanguage: "Language Interpreted",
  secondConsentedInLanguage: "I consented this patient in:",
  patient: "Patient Signature",
  authorized: "Legally Authorized Person Signature",
  witness: "Witness to signature / phone consent",
  interpreter: "Qualified Staff / Interpreter Signature",
  physician: "Physician / Credentialed Practitioner Authentication",
  second_physician: "Physician / Credentialed Practitioner Authentication",
};

const es: Record<string, string> = {
  ...en,
  doctorName: "Doctor",
  procedure: "Nombre de la cirugía o procedimiento: incluya el lugar, el lado y el nivel, si corresponde",
  secondDoctorName: "Si va a tener una 2ª cirugía/procedimiento:",
  secondProcedure: "Nombre de la cirugía o procedimiento: incluya el lugar, el lado y el nivel, si corresponde",
  otherRisks: "Otros riesgos involucrados. Se enumeran a continuación:",
  biopsyChoice: "Marque el casillero en la sección A. o B. a continuación:",
  dna_yes:
    "SÍ, quiero una prueba de análisis de ADN si fuese necesario para averiguar la causa de mi problema.",
  dna_no:
    "NO, NO deseo un análisis de ADN. Si es necesario el análisis de ADN, entiendo que es posible que mi médico no pueda diagnosticar o tratarme adecuadamente.",
  no_biopsy: "B. No se tomarán muestras para biopsia.",
  whichISpeak: "que hablo con fluidez.",
  patientPrintName: "Nombre y apellido del paciente en imprenta",
  authorizedName: "Nombre en imprenta",
  authorizedRelationship: "Relación",
  witnessPrintName: "Nombre del testigo en imprenta",
  unableReason: "El paciente no puede firmar porque:",
  sedated: "sedado",
  confused: "confundido / no alerta o desorientado",
  other: "otro (especifique)",
  unableOther: "otro (especifique)",
  phone: "Teléfono",
  video: "Video",
  interpreterName: "Nombre del personal calificado / intérprete en imprenta",
  interpreterId: "Número de ID",
  interpreterLanguage: "Idioma interpretado",
  physicianId: "N.º de ID",
  physicianLanguage: "Idioma interpretado",
  consentedInLanguage: "Di el consentimiento a este paciente en:",
  secondPhysicianId: "N.º de ID",
  secondPhysicianLanguage: "Idioma interpretado",
  secondConsentedInLanguage: "Di el consentimiento a este paciente en:",
  patient: "Firma del paciente",
  authorized: "Firma de la persona legalmente autorizada",
  witness: "Testigo de firma / consentimiento telefónico",
  interpreter: "Firma del personal calificado / intérprete",
  physician: "Autenticación del médico / profesional acreditado",
  second_physician: "Autenticación del médico / profesional acreditado",
};

export const econsentFieldOrder = [
  "doctorName",
  "procedure",
  "secondDoctorName",
  "secondProcedure",
  "otherRisks",
  "biopsyChoice",
  "unableReason",
  "unableOther",
  "patientPrintName",
  "authorizedName",
  "authorizedRelationship",
  "witnessPrintName",
  "interpreterMode",
  "interpreterName",
  "interpreterId",
  "interpreterLanguage",
  "physicianId",
  "consentedInLanguage",
  "physicianLanguage",
  "secondPhysicianId",
  "secondConsentedInLanguage",
  "secondPhysicianLanguage",
] as const;

export const econsentSlots = [
  "patient",
  "authorized",
  "witness",
  "interpreter",
  "physician",
  "second_physician",
] as const;

export function econsentLabel(language: string, key: string): string {
  const table = language === "es" ? es : en;
  return table[key] || key;
}

export function econsentFieldValue(language: string, key: string, raw: unknown): string {
  if (raw == null || raw === "") return "";
  if (typeof raw === "boolean") {
    if (!raw) return "";
    if (key === "consentedInLanguage" || key === "secondConsentedInLanguage") {
      return econsentLabel(language, "whichISpeak");
    }
    return econsentLabel(language, key);
  }
  const text = String(raw);
  if (key === "biopsyChoice" || key === "unableReason" || key === "interpreterMode") {
    return econsentLabel(language, text) || text;
  }
  return text;
}
